import PatientSelector from "./PatientSelector";

export default PatientSelector;